var isParentWrapped = function isParentWrapped(_ref) {
  var largeMedia = _ref.largeMedia,
      mediaPosition = _ref.mediaPosition,
      cardWidth = _ref.cardWidth;

  if (largeMedia) {
    return mediaPosition === 'right' && cardWidth <= 1081 || cardWidth <= 1071;
  } else {
    return mediaPosition === 'right' && cardWidth <= 951 || cardWidth <= 941;
  }
};

export { isParentWrapped };